import React from 'react';
import { Link } from 'react-router-dom';
import InstagramFeed from '../components/InstagramFeed';
import { ROUTES, socialLinks } from '../data/siteLinks';

const HakkimizdaPage: React.FC = () => {
  return (
    <div className="hakkimizda-page">
      <div className="container hakkimizda-content-wrap">
        {/* Hero / Bio Section */}
        <section className="hakkimizda-hero">
          <div className="hakkimizda-images">
            <img
              src="/images/hakkimizda-full.png"
              alt="Ayşegül Saraç"
              className="hakkimizda-image"
              loading="lazy"
              decoding="async"
            />
          </div>
          <div className="hakkimizda-content">
            <h1>Ayşegül Saraç Hakkında</h1>
            <p>
              2020 yılında ailemle birlikte İstanbul'dan Köln'e taşındım. Bu süreçte hem taşınma öncesi hazırlıklarda hem de yerleşim sonrası bürokratik adımlarda edindiğim tecrübeler, bugün başkalarının yolculuğuna kendi deneyimlerimi aktarmamın temelini oluşturdu.
            </p>
            <p>
              Almanya'ya göçün getirdiği zorlukları ve entegrasyon sürecini paylaşma tutkumla{' '}
              <Link to={ROUTES.blog}>"Göç Notları" blogunu</Link> ve{' '}
              <a href={socialLinks.youtube} target="_blank" rel="noopener noreferrer">
                YouTube kanalımı
              </a>{' '}
              kurdum. Vize hazırlığından ev kiralamaya, okul kaydından Blue Card başvuru hazırlık süreçlerine kadar pek çok konuda kişisel deneyimlerimi aktarıyorum.
            </p>
            <p>
              Bugün, Almanya'ya taşınmayı planlayan bireyler ve ailelerle deneyimlerimi paylaşıyor ve onlara resmi işlemlerin hazırlığına dair ipuçları veriyorum. Yeni bir ülkeye taşınmanın getirdiği belirsizlikleri bildiğim için, bu yolda bilgilerimi sizlerle paylaşmaktan mutluluk duyuyorum.
            </p>
            <p className="signature">Sevgiler, Ayşegül</p>
          </div>
        </section>

        {/* Legal Framework Section */}
        <section className="legal-section">
          <h2>ÇALIŞMA ALANI VE SINIRLARI</h2>
          <p>
            Sunulan hizmetler; kişisel deneyim paylaşımı, genel bilgilendirme ve taşınma sürecine yönelik organizasyonel hazırlık desteğiyle sınırlıdır. Somut duruma ilişkin hukuki değerlendirme, hukuk danışmanlığı ve resmi makamlar önünde temsil gerektiren işlemler hukuk ortağımız Avukat Dr. Hayrullah Özcan tarafından yürütülür.
          </p>
        </section>

      </div>
      {/* Instagram Feed — full bleed (container'ın dışında) */}
      <InstagramFeed title="Bizi Instagram'da takip edin!" />
    </div>
  );
};

export default HakkimizdaPage;
